module.exports = __webpack_public_path__ + "img/p-50.3ba94a0d.png";